import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const ChevronDown = (props: SvgIconProps) => {
  return (
    <SvgIcon width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
      <path fill="currentColor"
            d="M3.146 5.646a.5.5 0 0 1 .708 0L8 9.793l4.146-4.147a.5.5 0 0 1 .708.708l-4.5 4.5a.5.5 0 0 1-.708 0l-4.5-4.5a.5.5 0 0 1 0-.708Z"/>
    </SvgIcon>
  );
};
